export const QUARTER_GOALS_REPORT_TOKEN = '{quarter_goals_report_post}';

const decodeBase64Url = (base64url) => {
  const padding = '='.repeat((4 - (base64url.length % 4)) % 4);
  const base64 = (base64url + padding).replace(/-/g, '+').replace(/_/g, '/');
  return atob(base64);
};

/**
 * @param {string|undefined|null} text
 * @returns {object|null}
 */
export const parseQuarterGoalsReportPayload = (text) => {
  if (!text || !text.includes(QUARTER_GOALS_REPORT_TOKEN)) {
    return null;
  }
  const match = text.match(/\|payload:([A-Za-z0-9_-]+)$/);
  if (!match?.[1]) {
    return null;
  }
  try {
    const json = decodeBase64Url(match[1]);
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const isQuarterGoalsReportActivity = (text) =>
  !!text?.includes(QUARTER_GOALS_REPORT_TOKEN);
